<div class="channel-image-viewer">
    <header class="viewer-header">
        <h1 class="viewer-title montserrat-bold">{{ channelName }}</h1>
        <span *ngIf="hasNavigation" class="viewer-counter">{{ currentIndex + 1 }} / {{ images.length }}</span>
    </header>

    <main class="viewer-body">
        <p *ngIf="isLoading" class="viewer-message">Loading images...</p>
        <p *ngIf="!isLoading && hasError" class="viewer-message">Images could not be loaded.</p>
        <p *ngIf="!isLoading && !hasError && !images.length" class="viewer-message">No images for this channel.</p>

        <ng-container *ngIf="!isLoading && !hasError && images.length">
            <button *ngIf="hasNavigation" type="button" class="viewer-nav viewer-nav-previous"
                title="Previous image" aria-label="Previous image" (click)="previous()">
                &#8249;
            </button>
            <img class="viewer-image" [src]="currentImage"
                [alt]="channelName + (hasNavigation ? ' (' + (currentIndex + 1) + ' / ' + images.length + ')' : '')" />
            <button *ngIf="hasNavigation" type="button" class="viewer-nav viewer-nav-next"
                title="Next image" aria-label="Next image" (click)="next()">
                &#8250;
            </button>
        </ng-container>
    </main>
</div>
